import { Pencil, Trash2, Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

export type TagItem = { key: string; name: string; count: number };

type Props = {
  item: TagItem;
  isSelected: boolean;
  isEditing: boolean;
  editingValue: string;
  busy: boolean;
  onToggle: () => void;
  onEditStart: () => void;
  onEditChange: (value: string) => void;
  onEditCancel: () => void;
  onEditSave: () => void;
  onDelete: () => void;
};

export const PromptTagListRow = ({
  item,
  isSelected,
  isEditing,
  editingValue,
  busy,
  onToggle,
  onEditStart,
  onEditChange,
  onEditCancel,
  onEditSave,
  onDelete,
}: Props) => (
  <li className="flex items-center gap-2 px-3 py-2">
    <Checkbox checked={isSelected} onCheckedChange={onToggle} aria-label={`Select ${item.name}`} />
    {isEditing ? (
      <>
        <Input
          value={editingValue}
          onChange={(e) => onEditChange(e.target.value)}
          className="h-7 flex-1"
          autoFocus
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onEditSave();
            } else if (e.key === "Escape") {
              onEditCancel();
            }
          }}
        />
        <Button size="sm" variant="ghost" disabled={busy} onClick={onEditSave} aria-label="Save">
          <Check className="h-3.5 w-3.5" />
        </Button>
        <Button size="sm" variant="ghost" onClick={onEditCancel} aria-label="Cancel">
          <X className="h-3.5 w-3.5" />
        </Button>
      </>
    ) : (
      <>
        <span className="flex-1 truncate text-sm">{item.name}</span>
        <span className="text-xs text-muted-foreground">
          {item.count === 0 ? "unused" : `${item.count} prompt${item.count === 1 ? "" : "s"}`}
        </span>
        <Button size="sm" variant="ghost" onClick={onEditStart} aria-label="Rename">
          <Pencil className="h-3.5 w-3.5" />
        </Button>
        <Button size="sm" variant="ghost" onClick={onDelete} aria-label="Delete">
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </>
    )}
  </li>
);
